import { listClasses } from '@mui/material/List';
import { menuItemClasses } from '@mui/material/MenuItem';
/** Set on a v2 menu list once the pointer has moved focus in it; the row highlight keys on it. */
export const MENU_POINTER_ATTRIBUTE = 'data-menu-pointer';
const POINTER_LIST = `[${MENU_POINTER_ATTRIBUTE}]`;
const FOCUSED_TEXT_FIELD = 'input:not([type="checkbox"]):not([type="radio"]):focus';
/**
 * The highlighted row: the focused one, whether the keyboard or the pointer moved focus there.
 * Plain hover counts only where the pointer does not move focus: a row outside a menu list, or
 * any row while a filter field in the menu keeps focus.
 */
export const MENU_ITEM_HIGHLIGHT_SELECTOR = [
    `&.${menuItemClasses.focusVisible}`,
    `&.${menuItemClasses.selected}.${menuItemClasses.focusVisible}`,
    `${POINTER_LIST} &:focus`,
    `&:hover:not(${POINTER_LIST} *)`,
    `${POINTER_LIST}:has(${FOCUSED_TEXT_FIELD}) &:hover`,
].join(', ');
/**
 * Moves focus to the menu row under the pointer, so the highlight stays on that row after the
 * pointer leaves and the arrow keys carry on from it, as in SelectMenu and Autocomplete. A text
 * field inside the menu (a filter) keeps focus, so typing into it is never cut off.
 */
export function focusMenuItemUnderPointer(event) {
    const item = event.currentTarget;
    const list = item.closest(`.${listClasses.root}`);
    const active = document.activeElement;
    // React bubbles events out of portals, so a submenu rendered inside this row reaches it too.
    const fromPortal = event.target instanceof Node && !item.contains(event.target);
    if (!list ||
        fromPortal ||
        item === active ||
        (isTextEntry(active) && list.contains(active))) {
        return;
    }
    list.setAttribute(MENU_POINTER_ATTRIBUTE, '');
    item.focus({ preventScroll: true });
}
function isTextEntry(element) {
    if (element instanceof HTMLInputElement) {
        return element.type !== 'checkbox' && element.type !== 'radio';
    }
    return (element instanceof HTMLTextAreaElement ||
        (element instanceof HTMLElement && element.isContentEditable));
}
